export const DATE_FORMAT = 'DD/MM/YYYY HH:mm';
export const ONLY_DATE_FORMAT = 'DD/MM/YYYY HH:mm';
export const DATE_ONLY_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_SECONDS_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const TIME_SECONDS_FORMAT = 'HH:mm:ss';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
